import React, { useState, useRef, useEffect } from "react";
import Notifications from "components/vmisc/notifications/Notifications";

function NotificationsBell({ 
  flow, 
  isDebug = false
}) {

  const containerRef = useRef(null);
  const notificationsRef = useRef(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const [notificationsHash, setNotificationsHash] = useState("");

  const pendingNotificationslength = pendingNotifications?.length || 0;

  const onClickNotificationBell = () => {
    setIsCollapsed(!isCollapsed);
    if(isCollapsed) notificationsRef?.current?.refetchNotifications();
  }

  const onLoadNotifications = (notifications) => {

    const hash = JSON.stringify(notifications);
    if (hash === notificationsHash) return;

    setPendingNotifications(notifications);
    setNotificationsHash(hash);
    notificationsRef?.current?.updatePendingNotifications(notifications);

  }

  useEffect(() => {

    const handleClickOutside = (event) => {

      if (containerRef.current && !containerRef.current.contains(event.target)) {

        setIsCollapsed(false);

        if (isCollapsed)
          notificationsRef?.current?.refetchNotifications();

      }
      
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    }

  }, [containerRef, isCollapsed]);
  
  return (
    <div ref={containerRef} className="position-relative">

      <button 
        id="chat-notifications"
        className="btn btn-sm btn-outline-primary text-center mr-2 position-relative h-100"
        style={{paddingLeft: "0.9rem", paddingRight: "0.9rem"}}
        onClick={onClickNotificationBell}
      >
        <i className="fas fa-bell" />
        {
          pendingNotificationslength > 0 &&
            <span className="badge badge-danger position-absolute"
              style={{top: "-0.5rem", right: "-0.5rem", fontSize: "0.8rem"}}>
              {pendingNotificationslength}
            </span>
        }
      </button>

      <div 
        className="card-body px-3 py-2 position-absolute bg-white shadow-lg rounded"
        style={{
          width: "20rem",
          top: "2.5rem",
          right: "0",
          display: isCollapsed ? "block" : "none",
        }}
      >
        <Notifications
          ref={notificationsRef}
          flow={flow}
          isDebug={isDebug}
          onLoadNotifications={onLoadNotifications}
        />
      </div>

    </div>
  );
}

export default NotificationsBell;